import { render, staticRenderFns } from "./TeamSeatModal.vue?vue&type=template&id=a65ea032&scoped=true"
import script from "./TeamSeatModal.vue?vue&type=script&lang=js"
export * from "./TeamSeatModal.vue?vue&type=script&lang=js"
import style0 from "./TeamSeatModal.vue?vue&type=style&index=0&id=a65ea032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ea032",
  null
  
)

export default component.exports